import React from 'react';
import { Main } from '../components/Main/Main';
import { Outlet } from 'react-router-dom';
import { useUserData } from '../hooks/useUserData';
import { useLocationChange } from '../hooks/useLocationChange';

declare const window: {
  location: {
    pathname: string;
  };
  hideMintMedicalStoreLogoutNavLink: () => void;
  showMintMedicalStoreAccountNavLink: () => void;
  showMintMedicalStoreLogoutNavLink: () => void;
  hideMintMedicalStoreAccountNavLink: () => void;
};

export function MainLayout() {
  const { userData } = useUserData();
  const pathName = window.location.pathname;
  useLocationChange((newPathName) => {
    console.log('MainLayout useLocationChange', newPathName);
    if (newPathName.startsWith('/account')) {
      window.showMintMedicalStoreLogoutNavLink && window.showMintMedicalStoreLogoutNavLink();
      window.hideMintMedicalStoreAccountNavLink && window.hideMintMedicalStoreAccountNavLink();
    } else {
      window.hideMintMedicalStoreLogoutNavLink && window.hideMintMedicalStoreLogoutNavLink();
      window.showMintMedicalStoreAccountNavLink && window.showMintMedicalStoreAccountNavLink();
    }
  });

  if (userData) {
    if (pathName.startsWith('/account')) {
      window.showMintMedicalStoreLogoutNavLink && window.showMintMedicalStoreLogoutNavLink();
      window.hideMintMedicalStoreAccountNavLink && window.hideMintMedicalStoreAccountNavLink();
    } else {
      window.hideMintMedicalStoreLogoutNavLink && window.hideMintMedicalStoreLogoutNavLink();
      window.showMintMedicalStoreAccountNavLink && window.showMintMedicalStoreAccountNavLink();
    }
    console.log('MainLayout.');
  }

  return (
    <Main>
      <Outlet></Outlet>
    </Main>
  );
}
